import React from 'react';

const LearnosityMcqTemplate = ({ showCustomMeta = true }) => (
  <div type="text/template" data-lrn-qe-layout="mcq_1" hidden>
    <div className="lrn-qe-edit-form">
      <div className="error-stimulus-portal" />
      <h5 className="lrn-qe-heading">Compose question</h5>
      <span data-lrn-qe-input="stimulus" className="lrn-qe-ckeditor-lg" />

      <div className="error-options-portal" />
      <h5 className="lrn-qe-heading">Multiple Choice Options</h5>
      <div data-lrn-qe-loop="options[*]">
        <span data-lrn-qe-input="options[*].label" />
      </div>
      <span data-lrn-qe-action-add="options" />

      <div className="error-correct-portal" />
      <h5 className="lrn-qe-heading">Set Correct Answer(s)</h5>

      <span data-lrn-qe-input="validation.valid_response.value" />

      <div data-lrn-qe-layout-wrapper="">
        <span
          data-lrn-qe-input="multiple_responses"
          className="lrn-qe-inline-block"
        />
        <span
          data-lrn-qe-label="multiple_responses"
          className="lrn-qe-inline-block lrn-qe-margin-left-xs"
        />
      </div>

      <h5 className="lrn-qe-heading">Rationales and Distractors</h5>

      {showCustomMeta ? (
        <div data-lrn-qe-custom-metadata="true">
          <div data-lrn-qe-loop="metadata.custom_distractor_rationale_response_level[*]">
            <span className="lrn-qe-distractor-label">Answer</span>
            <div data-lrn-qe-input="metadata.custom_distractor_rationale_response_level[*]" />
          </div>
        </div>
      ) : (
        <div data-lrn-qe-section="metadata.content">
          <div data-lrn-qe-custom-metadata="true" hidden />
          <div data-lrn-qe-loop="metadata.distractor_rationale_response_level[*]">
            <span className="lrn-qe-distractor-label">Answer</span>
            <div data-lrn-qe-input="metadata.distractor_rationale_response_level[*]" />
          </div>
          <span data-lrn-qe-action-add="metadata.distractor_rationale_response_level" />
        </div>
      )}
    </div>
  </div>
);

export default LearnosityMcqTemplate;
